import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

import moment from "moment";

import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { es } from "date-fns/locale";

// estilos
import "../../assets/style/componentPrincipal.css";
import "./pptosNew.css";

import "../../assets/style/tablesG.css";

// componentes
import { Buscar } from "../general/buscador/Buscar";
import { Crear } from "../general/crear/Crear";
// import { ExportarPlanilla } from '../general/exportarPlanilla/ExportarPlanilla'

// redux
import {
  budgetsSetFiltersList,
  iniCargarPptos,
} from "../../redux/actions/pptos";
import { ListTables } from "../tables/ListTables";
import { VerReporte } from "../general/verReporte/VerReporte";
import { DialogImports } from "../imports/DialogImports";
import { BudgetListTotals } from "./list/BudgetListTotals";
// import { ListMovil } from '../tables/ListMovil'

const listaTitulos = [
  { title: "Número" },
  { title: "Referencia" },
  { title: "Cliente" },
  { title: "Total base" },
  { title: "Rentabilidad" },
  { title: "Ejecutivo" },
  { title: "Últ. Modificación" },
];

export const PptosList = () => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const filtersDefaultDate = useSelector((state) => state.ppto.ppto_filters);
  const [searchParams] = useSearchParams();
  const fromHome = searchParams.get("from") === "inicio";
  const [summary, setSummary] = useState({
    totals: null,
    loading: true,
    error: false,
  });

  const dispatch = useDispatch();
  const [openDialogModalImports, setOpenDialogModalImports] = useState(false);

  const [filters, setFiltersState] = useState({
    time: fromHome ? "all" : filtersDefaultDate?.time || "all",
    estado_validacion: "",
    text: "",
    fecha_desde: filtersDefaultDate?.fecha_desde || new Date(),
    fecha_hasta: filtersDefaultDate?.fecha_hasta || new Date(),
    por_aprobar: true,
    anulado: false,
    id_ejecutivo: "",
    page: 1,
    rows: 10,
  });

  const setFilters = (next) =>
    setFiltersState((previous) => {
      const updated = typeof next === "function" ? next(previous) : next;
      const changed = [
        "time",
        "text",
        "fecha_desde",
        "fecha_hasta",
        "por_aprobar",
        "anulado",
        "id_ejecutivo",
        "estado_validacion",
      ].some((key) => String(previous[key]) !== String(updated[key]));
      return { ...updated, page: changed ? 1 : updated.page };
    });

  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    setSummary({ totals: null, loading: true, error: false });
    dispatch(iniCargarPptos(filters, { signal: controller.signal })).then(
      (body) => {
        if (active)
          setSummary({
            totals: body?.totals || null,
            loading: false,
            error: !body?.totals,
          });
      },
    );
    dispatch(
      budgetsSetFiltersList({
        time: filters?.time,
        fecha_desde: filters?.fecha_desde,
        fecha_hasta: filters?.fecha_hasta,
      }),
    );
    return () => {
      active = false;
      controller.abort();
    };
  }, [dispatch, filters]);

  const handleChangeDateDesde = (newValue) => {
    console.log(newValue);
    setFilters({
      ...filters,
      fecha_desde: newValue,
    });
  };

  const handleChangeDateHasta = (newValue) => {
    console.log(newValue);
    setFilters({
      ...filters,
      fecha_hasta: newValue,
    });
  };

  return (
    <div className="p-container">
      {!isMobile ? (
        <h1 className="p-title">Presupuestos por aprobar</h1>
      ) : (
        <h1 style={{ fontSize: "18px", margin: "10px 10px" }}>Presupuestos</h1>
      )}

      {openDialogModalImports && (
        <DialogImports
          open={openDialogModalImports}
          setOpen={setOpenDialogModalImports}
          detail={{ id: 0, items: [] }}
        />
      )}

      {!isMobile && (
        <DateFilters
          filters={filters}
          setFilters={setFilters}
          handleChangeDateDesde={handleChangeDateDesde}
          handleChangeDateHasta={handleChangeDateHasta}
        />
      )}

      <div className="flex justify-between items-center mt-2">
        <div className="flex gap-2 items-center">
          <Buscar filters={filters} setFilters={setFilters} />
          <Crear
            openDialogModalImports={openDialogModalImports}
            setOpenDialogModalImports={setOpenDialogModalImports}
          />
        </div>

        {!isMobile ? (
          <div>
            {/* <ExportarPlanilla /> */}
            <VerReporte />
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="row p-box-filters">
        <div className="col p-box-filters-items">
          <Link
            to="/ppto"
            className={!filters.anulado ? `selected` : ""}
            onClick={() =>
              setFilters({ ...filters, anulado: false, por_aprobar: true })
            }
          >
            Presupuestos por aprobar
          </Link>
          <Link to="/projects">Proyectos aprobados</Link>
          <Link
            to=""
            className={filters.anulado ? `selected` : ""}
            onClick={() =>
              setFilters({ ...filters, anulado: true, por_aprobar: false })
            }
          >
            Anulados
          </Link>
        </div>
      </div>

      {fromHome && (
        <p className="p-budget-list-comparison">
          Vista de Inicio: todos los presupuestos por aprobar, consolidados en
          soles. Cambiar los filtros modifica el total.
        </p>
      )}
      <BudgetListTotals {...summary} />

      <ListTables
        listaTitulos={listaTitulos}
        filters={filters}
        setFilters={setFilters}
        totalCount={summary.totals?.count}
        loading={summary.loading}
        error={summary.error}
      />

      {/* {!isMobile ?
                <ListTables
                    listaTitulos={listaTitulos}
                    filters={filters}
                    setFilters={setFilters}
                />
                :
                <ListMovil
                    listaTitulos={listaTitulos}
                    filters={filters}
                    setFilters={setFilters}
                />
            } */}
    </div>
  );
};

const DateFilters = ({
  filters,
  setFilters,
  handleChangeDateDesde,
  handleChangeDateHasta,
}) => {
  return (
    <>
      <div className="row mt-3">
        <div className="col text-start">
          <div
            className="btn-group"
            role="group"
            aria-label="Basic radio toggle button group"
          >
            <input
              type="radio"
              className="btn-check"
              name="btnradio"
              id="btnradio1"
              autoComplete="off"
              checked={filters.time === "all" && "checked"}
              onChange={() => setFilters({ ...filters, time: "all" })}
            />
            <label
              className="btn btn-outline-light"
              htmlFor="btnradio1"
              style={{ color: filters.time === "all" ? "#8E24AA" : "#595759" }}
            >
              Todos en proceso
            </label>

            <input
              type="radio"
              className="btn-check"
              name="btnradio"
              id="btnradio2"
              autoComplete="off"
              checked={filters.time === "year" && "checked"}
              onChange={() => setFilters({ ...filters, time: "year" })}
            />
            <label
              className="btn btn-outline-light"
              htmlFor="btnradio2"
              style={{ color: filters.time === "year" ? "#8E24AA" : "#595759" }}
            >
              Anual ({moment(filters.fecha_desde).format("YYYY")})
            </label>

            <input
              type="radio"
              className="btn-check"
              name="btnradio"
              id="btnradio3"
              autoComplete="off"
              checked={filters.time === "month" && "checked"}
              onChange={() => setFilters({ ...filters, time: "month" })}
            />
            <label
              className="btn btn-outline-light"
              htmlFor="btnradio3"
              style={{
                color: filters.time === "month" ? "#8E24AA" : "#595759",
              }}
            >
              Mensual (
              <span style={{ textTransform: "capitalize" }}>
                {moment(filters.fecha_desde).format("MMMM")}
              </span>{" "}
              {moment(filters.fecha_desde).format("YYYY")})
            </label>

            <input
              type="radio"
              className="btn-check"
              name="btnradio"
              id="btnradio4"
              autoComplete="off"
              checked={filters.time === "range" && "checked"}
              onChange={() => setFilters({ ...filters, time: "range" })}
            />
            <label
              className="btn btn-outline-light"
              htmlFor="btnradio4"
              style={{
                color: filters.time === "range" ? "#8E24AA" : "#595759",
              }}
            >
              Rango
            </label>
          </div>
        </div>
      </div>

      {filters.time === "year" && (
        <div className="mt-4 p-text-date-year">
          <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year"]}
              label="Año"
              openTo="year"
              name="fecha_desde"
              // minDate={new Date('2000-01-01')}
              value={filters.fecha_desde}
              onChange={handleChangeDateDesde}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </LocalizationProvider>
        </div>
      )}

      {filters.time === "month" && (
        <div className="mt-4 p-text-date-month">
          <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["year", "month"]}
              label="Mes"
              openTo="month"
              name="fecha_desde"
              // minDate={new Date('2000-01-01')}
              value={filters.fecha_desde}
              onChange={handleChangeDateDesde}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </LocalizationProvider>
        </div>
      )}

      {filters.time === "range" && (
        <div className="row mt-4">
          <div className="col text-start d-flex justify-content-start p-text-date-range">
            <span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="Mes desde"
                  inputFormat="DD/MM/YYYY"
                  name="fecha_desde"
                  value={filters.fecha_desde}
                  onChange={handleChangeDateDesde}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </span>
            <span style={{ marginLeft: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  label="Mes hasta"
                  inputFormat="DD/MM/YYYY"
                  name="fecha_hasta"
                  value={filters.fecha_hasta}
                  onChange={handleChangeDateHasta}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </span>
          </div>
        </div>
      )}
    </>
  );
};
